// src/components/Layout/Layout.js
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import UniversalHeader from '../UniversalHeader/UniversalHeader';
import TutorialModal from '../TutorialModal/TutorialModal';
import ContactButton from '../ContactButton/ContactButton';
import ContactModal from '../ContactModal/ContactModal';
import './Layout.css';

const isMobileScreen = () => window.innerWidth <= 768;
const HAS_SEEN_TUTORIAL_KEY = 'vividyear_has_seen_tutorial_session';

const Layout = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(!isMobileScreen());
  const [isTutorialVisible, setIsTutorialVisible] = useState(false);
  const [isContactModalOpen, setContactModalOpen] = useState(false);
  
  useEffect(() => {
    const hasSeenTutorial = sessionStorage.getItem(HAS_SEEN_TUTORIAL_KEY);
    if (!hasSeenTutorial) {
      setIsTutorialVisible(true);
    }
  }, []);

  const handleCloseTutorial = () => {
    setIsTutorialVisible(false);
    sessionStorage.setItem(HAS_SEEN_TUTORIAL_KEY, 'true');
  };
  
  useEffect(() => {
    const handleResize = () => {
      if (!isMobileScreen()) {
        setIsSidebarVisible(true);
      } else {
        setIsSidebarVisible(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  return (
    <div className={`app-container ${isSidebarVisible ? 'sidebar-visible' : 'sidebar-hidden'}`}>
      {isTutorialVisible && <TutorialModal onClose={handleCloseTutorial} />}
      
      {isContactModalOpen && <ContactModal onClose={() => setContactModalOpen(false)} />}

      <UniversalHeader onMenuClick={toggleSidebar} />
      
      <main className="page-content">
        <Outlet context={{ isSidebarVisible }} />
      </main>
      
      <ContactButton onClick={() => setContactModalOpen(true)} />

      {isSidebarVisible && isMobileScreen() && <div className="mobile-overlay" onClick={toggleSidebar} />}
    </div>
  );
};

export default Layout;